import React, { useContext } from 'react'
import {
    StyledActionsContainer,
    StyledActionsContent,
    StyledActionGroup,
} from './TheWestHeaderActions.styled'
import { RenderTargetContext } from 'common/context-providers/render-target-context'
import { AuthSiteLoginActionLinks } from '../TheWestHeaderLogin/TheWestAuthSiteLogin'
import { SearchAction } from './SearchAction'
import { MenuAction, MenuActionProps } from './MenuAction'
import { HomeAction } from './HomeAction'
import { WestLiveAction } from './WestLiveAction'
import { AuthenticationProvider } from 'component-library/user-registration/authentication/AuthenticationProvider'
import { FeatureToggle } from 'component-library/feature-toggling/Toggle/Toggle'
import {
    useOnAirState,
    useScheduleWindow,
} from 'component-library/content/TheWestLive/TheWestLiveProvider'

export interface Props extends MenuActionProps {
    onEvent: (event: any) => void
}

export const TheWestActionsStructure: React.FC<{
    left: React.ReactElement
    right: React.ReactElement | false
}> = ({ left, right }) => {
    return (
        <StyledActionsContainer>
            <StyledActionsContent>
                {left}

                {right && <StyledActionGroup>{right}</StyledActionGroup>}
            </StyledActionsContent>
        </StyledActionsContainer>
    )
}

export const TheWestHeaderActions: React.FC<Props> = ({ onEvent, ...menuActionProps }) => {
    const renderTarget = useContext(RenderTargetContext)
    const inSchedule = useScheduleWindow()
    const onAir = useOnAirState()

    return (
        <TheWestActionsStructure
            left={
                <FeatureToggle
                    feature="the-west-live"
                    on={() => {
                        return (
                            <React.Fragment>
                                {renderTarget.renderTarget !== 'static-error-page' && (
                                    <MenuAction {...menuActionProps} children="" />
                                )}
                                {inSchedule && <WestLiveAction showEqualizer={onAir} />}
                            </React.Fragment>
                        )
                    }}
                    off={() => {
                        return (
                            <React.Fragment>
                                {renderTarget.renderTarget !== 'static-error-page' && (
                                    <MenuAction {...menuActionProps} />
                                )}
                                <HomeAction />
                            </React.Fragment>
                        )
                    }}
                />
            }
            right={
                renderTarget.renderTarget !== 'static-error-page' && (
                    <React.Fragment>
                        <FeatureToggle feature={'search'} on={() => <SearchAction />} />
                        <AuthenticationProvider onEvent={onEvent}>
                            {({ onLoginClick, onLogoutClick, onSubscribeClick }) => (
                                <AuthSiteLoginActionLinks
                                    onSubscribeClick={onSubscribeClick}
                                    onLogoutClick={onLogoutClick}
                                    onLoginClick={onLoginClick}
                                    onEvent={onEvent}
                                />
                            )}
                        </AuthenticationProvider>
                    </React.Fragment>
                )
            }
        />
    )
}
TheWestHeaderActions.displayName = 'TheWestHeaderActions'
